import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
//const authentication = require('react-azure-adb2c').default;
//import { Dispatch } from 'redux';


import { call, put, takeEvery, select } from 'redux-saga/effects';
import * as Response_Data_Api from '../Api/ResponseDataApi';



///types
const moment = require('moment')

export interface State {

    media_list: any;
    respose_list: any;

}
const initialState: State = {

    media_list: [],
    respose_list: []

}



///action 
const actionCreator = actionCreatorFactory();


export const get_media_list = actionCreator('GET_MEDIA_LIST');
export const get_media_list_success = actionCreator('GET_MEDIA_LIST_SUCCESS');


export const response_search = actionCreator('RESPONSE_SEARCH');
export const response_search_success = actionCreator('RESPONSE_SEARCH_SUCCESS');



export const ResponseDataReducer = reducerWithInitialState(initialState)
    .case(get_media_list_success, (state, payload) => ({ ...state, media_list: payload }))
    .case(response_search_success, (state, payload) => ({ ...state, respose_list: payload }))


// 「LOGIN_REQUEST」アクションが呼ばれるのを待つ呼ばれたhandleRequestを実行
export const ResponseDataSaga = [

    takeEvery('GET_MEDIA_LIST', handle_get_media_list),
    takeEvery('RESPONSE_SEARCH', handle_response_search),

];



function* handle_get_media_list(action: any) {

    const { payload, error } = yield call(Response_Data_Api.media, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        yield put(get_media_list_success(payload));
    } else {
    }
}

function* handle_response_search(action: any) {

    const { payload, error } = yield call(Response_Data_Api.search, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        yield put(response_search_success(payload));
    } else {
    }
}
